import { Component, ChangeDetectionStrategy, Input, OnDestroy } from '@angular/core'
import { ReplaySubject } from 'rxjs'
import { map } from 'rxjs/operators'
import { trackById } from '../../../../shared/utility-functions/track-by-id.utility'
import { getAnalytics } from '../../../collections/functions/analytics'
import { Node } from 'src/io/models/node'

export interface NodeListComponentProps {
  nodes: ReadonlyArray<Node>
}

@Component({
  selector: 'flo-node-type-list',
  templateUrl: `./node-type-list.component.html`,
  styles: [
    `
      flo-node-list-item:first-child {
        padding-top: 0 !important;
        margin-top: 0 !important;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NodeTypeListComponent implements OnDestroy {
  private ngOnDestroy$ = new ReplaySubject<void>(1)

  private readonly props$ = new ReplaySubject<NodeListComponentProps>(1)
  @Input()
  set props(props: NodeListComponentProps) {
    if (!!props) {
      this.props$.next(props)
    }
  }

  public readonly listItemProps$ = this.props$.pipe(
    map(props => props.nodes),
    map(nodes =>
      nodes.map((node, i, arr) => {
        return {
          node,
          type: node.type,
          analyticsProps: getAnalytics(node as Node, i, arr.length)
        }
      })
    )
  )

  public ngOnDestroy(): void {
    this.ngOnDestroy$.next()
    this.ngOnDestroy$.complete()
  }

  public trackById = trackById
}
